<template>
  <div class="form">
    <slot>Form Content</slot>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  events: '',
  classes: true,
  fieldsBagName: 'veeValidateFields'
});

export default {
  name: 'FormComponent',
};
</script>

<style lang="scss" scoped>
$formerror: lighten($red, 12%);

.form {
  ::v-deep .form__input {
    position: relative;
    text-align: left;

    label {
      text-transform: uppercase;
      font-size: 0.75rem;
      letter-spacing: 0.1rem;
      margin-bottom: 4px;
    }

    input,
    select,
    textarea,
    .vue-tags-input .ti-input input {
      @include border-radius($border-radius);

      display: inline-block;
      width: 100%;
      max-width: 100%;
      height: 45px;
      margin-bottom: 15px;
      padding: 0 15px;
      border: $default-border;
      cursor: text;
      background: rgba(33, 54, 75, 1);
      color: white;

      &.no-border {
        border: solid 1px white;
      }

      &:focus {
        border: solid 1px $highlight-color;
        outline: 0;
        box-shadow: none;
        background: rgba(white, 0.9);
        border-color: white;
        color: rgba(black, 0.87);
      }

      &::placeholder {
        color: white;
      }

      &:-ms-input-placeholder {
        color: white;
      }

      &::-ms-input-placeholder {
        color: white;
      }
    }

    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
      -webkit-appearance: inner-spin-button !important;
    }

    select {
      background: rgba(33, 54, 75, 1);
      border: $default-border;
      cursor: pointer;
      padding: 0 15px;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;

      &.has-input {
        color: white;
      }

      &::-ms-expand {
        display: none;
      }

      &:focus {
        color: rgba(black, 0.87);
      }

      option {
        font-weight: normal;
      }

      ::v-deep .icon {
        color: $green !important;
      }
    }

    textarea {
      min-height: 180px;
      padding: 27px 17px 0;
      line-height: 1.2;

      &:focus {
        padding: 25px 15px 0;
      }
    }

    .form__error {
      height: auto;
      max-height: 0;
      margin-bottom: 0;
      padding-bottom: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-out;
    }

    &.form__input--error {
      .form__label {
        color: $formerror;
      }

      input,
      select,
      textarea {
        border: solid 1px $formerror;
        outline: 0;
        box-shadow: none;

        &:focus {
          border-color: $highlight-color;
        }
      }

      textarea {
        &:focus {
          padding: 25px 15px 0;
        }
      }

      .form__error {
        max-height: 200px;
        padding-bottom: 1rem;
        color: $formerror;
        transition: max-height 0.3s ease-out;
        position: relative;
        margin-top: -10px;
      }
    }

    &.flexcol {
      display: flex;
      flex-direction: column;
    }

    input.max100 {
      max-width: 100px;
    }
  }

  .check-btn {
    label {
      @include border-radius($border-radius);

      position: relative;
      display: inline-block !important;
      width: 100%;
      max-width: 100%;
      height: 45px;
      margin-bottom: 15px;
      padding: 0;
      border: $default-border;
      cursor: text;
      background: rgba(33, 54, 75, 1);
      color: white;
      text-align: center;
      line-height: 45px;

      &:hover {
        cursor: pointer;
        background: rgba(white, 0.2);
      }

      button {
        &:active,
        &.active,
        &:focus {
          outline: 0 !important;
        }
      }
    }

    input[type="radio"],
    input[type="checkbox"] {
      display: none !important;
    }

    input[type="radio"]:checked + label,
    input[type="checkbox"]:checked + label,
    .Checked + label {
      background: $green;
      border: solid 1px $green;
      color: $btn-color;
    }
  }

  .hide-label {
    ::v-deep label {
      display: none;
    }
  }
}

.form-wrapper__error {
  input,
  label {
    border: solid 1px $error !important;
    outline: 0 !important;
    box-shadow: none !important;
  }

  .form__error {
    max-height: 200px;
    padding-bottom: 1rem;
    color: $error;
    transition: max-height 0.3s ease-out;
    position: relative;
    margin-top: -10px;
  }
}
</style>
